import "../CSS/Drawing.scss"
import { motion, AnimatePresence} from "framer-motion";
import { useState} from "react";
import { Images } from "../Imports/images";
import { pageAnimation } from "../Variants/variants";
import DrawingCard from "./DrawingCard";

const Drawing = () => {
    const [drawings, setDrawings] = useState(Images);

    return(
        <motion.div 
        className="drawings-class" 
        variants={pageAnimation}
        initial="initial"
        animate="animate"
        exit="exit">
            <AnimatePresence>
                {drawings.map((image, index) => {
                    return(
                        <DrawingCard key={index} image={image}/>
                    )
                })}
            </AnimatePresence>
        </motion.div>
    );
}

export default Drawing;